import striveMark from './assets/strive-mark.png';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import ArrowForward from '@mui/icons-material/ArrowForward';
import RideInfo from './RideInfo';
import LocationHelp from './LocationHelp';
import './join-screen.css';

const HEADLINES = ['Join this Radio', 'Take over the music', 'Your turn on AUX', 'Control the music'];

// Presentation shared by the live permission gate and the isolated sample preview.
export default function JoinScreen({ denied = false, pending = false, error = '', onConnect }) {
  const [headline, setHeadline] = useState(0);
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  useEffect(() => {
    if (denied || pending || reducedMotion) return;
    const timer = setInterval(() => setHeadline(index => (index + 1) % HEADLINES.length), 4000);
    return () => clearInterval(timer);
  }, [denied, pending, reducedMotion]);
  const activeHeadline = reducedMotion ? 0 : headline;
  const feedback = pending ? 'Allow location when prompted.' : denied ? 'Checks that you’re near your driver.' : '';

  return <div className="join-screen">
    <header className="join-header"><div className="brand-section"><img className="brand-logo" src={striveMark} alt="" width="27" height="27" /><span className="brand-text">strive<span className="brand-domain">.fm</span></span></div><RideInfo showLabel /></header>
    <main className="join-main">
      <div className="join-location-icon" aria-hidden="true"><LocationOnOutlined /></div>
      {denied ? <h1>Allow location</h1> : <h1 className="join-headline" aria-label="Join this Radio">
        {HEADLINES.map((text, index) => <span key={text} className={index === activeHeadline ? 'active' : ''} aria-hidden="true">{text}</span>)}
      </h1>}
      <p className="join-intro">{denied ? 'Allow location for remote.strive.fm.' : 'Share your music with fellow listeners.'}</p>
      {denied ? <LocationHelp /> : <div className="join-location-note"><LocationOnOutlined aria-hidden="true" /><div><strong>Location required</strong><p>Checks that you’re near your driver.</p></div></div>}
      <button className="join-connect" onClick={onConnect} disabled={pending}><span>{pending ? 'Getting location…' : denied ? 'Try again' : 'Control the music'}</span>{!pending && <ArrowForward aria-hidden="true" />}</button>
      <div className="join-feedback" aria-live="polite">{error ? <p role="alert">{error}</p> : feedback ? <p>{feedback}</p> : null}</div>
    </main>
    <div className="join-waves" aria-hidden="true">
      <svg viewBox="0 24 150 28" preserveAspectRatio="none" focusable="false">
        <defs>
          <path id="join-gentle-wave" d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18v44h-352z" />
        </defs>
        <use href="#join-gentle-wave" x="50" y="0" />
        <use href="#join-gentle-wave" x="50" y="3" />
        <use href="#join-gentle-wave" x="50" y="6" />
      </svg>
    </div>
  </div>;
}
